import { Pipe, PipeTransform } from "@angular/core";
import { of } from "rxjs";

//  Converts an item into an observable
@Pipe({
    name: 'toObservable',
    standalone: false
})
export class ObservablePipe implements PipeTransform {
    transform(value: any): any {
        return of(value);
    }
}
